import { PageHeader } from '@/components/PageHeader';
import { Button } from '@predoc/cow';
import { Mail, Shield } from 'lucide-react';
import { USER_SETTINGS_LINKS } from '../constants';

export const Header = () => {
  const handleContactSupport = () => {
    window.location.href = `mailto:${USER_SETTINGS_LINKS.SUPPORT_EMAIL}`;
  };
  const handlePrivacyPolicy = () => {
    window.open(
      USER_SETTINGS_LINKS.PRIVACY_POLICY_URL,
      '_blank',
      'noopener,noreferrer',
    );
  };

  return (
    <PageHeader>
      <h1 className="text-primary text-3xl font-bold">User Settings</h1>

      <div className="flex items-center space-x-4">
        <Button
          variant="outline"
          tabIndex={0}
          aria-label="Contact Support"
          onClick={handleContactSupport}
        >
          <Mail className="mr-2 h-4 w-4" />
          <span>Contact Support</span>
        </Button>

        <Button
          variant="outline"
          tabIndex={0}
          aria-label="Privacy Policy"
          onClick={handlePrivacyPolicy}
        >
          <Shield className="mr-2 h-4 w-4" />
          <span>Privacy Policy</span>
        </Button>
      </div>
    </PageHeader>
  );
};
